<template>
  <div>
      <div class="box">
        <BInputPullDown
          label-name="机构名称"
          v-model="searchParam.organizationId"
          :Options="orgList"
          placeholder="请选择机构名称"
        />
        <BBtnSecondary
          :img-src="require('@/assets/icon_screen.png')"
          :clicked="doSearch"
          hidden-key="true"
          btn-txt="筛选"
          style="margin-left: 30px;"
        />
      </div>
      
      <div class="search-result">
      <Table
        :headers="headers"
        class="timeDiscount"
        :tableData="pageList"
        :length="totalPages"
        :total-visible="7"
        :page-num="pageNum"
        v-model="pageNum"
        @input="doSearch(false)"
      >
        <template v-slot:pageKnd1="item">
          <div
            style="display: flex; flex-direction: row; justify-content: center"
          >
           <div
              v-for="(it,index) in pageTypeList"
              :key="index"
            >
              <span v-if="item.pageKnd===it.value">{{ it.text }}</span>
            </div>
          </div>
        </template>
        <template v-slot:actions="item">
          <div style="display:flex;flex-direction:row;justify-content: center;">
            <div class="btn-detail" @click="handleDetail(item.data)">
              视频详情
            </div>
            <div class="btn-detail" @click="handleStudentDetail(item.data)">
              学生详情
            </div>
          </div>
        </template>
      </Table>
    </div>
  </div>
</template>
<script>
  import { totalSearch,listSearchInit } from '@/api/videoData'
  import BInputPullDown from "../../components2/BInputPullDown";
  import Table from "../../components2/Table";
  import BBtnSecondary from "../../components2/BBtnSecondary";
  import Hub from "../../events/Hub";
  export default {
    name: 'StudentManagement',
    components: {
      Table,
      BInputPullDown,
      BBtnSecondary,
    },
    data: () => ({
      deleteDialogFlag: false,
      loading: false,
      page: 0,
      totalPages: 0,
      pageNum: 1,
      pageCount: 10,
      totalCount: 0,
      searchParam: {},
      dialogTitleFlag: 0,
      dialogTitle: '',
      studentId: '',
      data: {},
      // 详情时不可保存
      saveFlag: false,
      snackbar: false,
      timeout: 3000,
      snackbarColor: 'success',
      snackbarText: '',
      nameFlag: false,
      attachmentFlag: false,
      originFlag: false,
      addressFlag: false,
      socialInsuranceNoFlag: false,
      politicsCodeFlag: false,
      educationalLevelFlag: false,
      nationIdFlag: false,
      sexFlag: false,
      idCardNumFlag: false,
      telNoFlag: false,
      headers: [
        { text: '编号', value: 'indexNum', sortable: false, align: 'center' },
        { text: '机构名称', value: 'orgName', sortable: false },
        { text: '学生人数', value: 'studentNum', sortable: false, align: 'center' },
        { text: '视频总数', value: 'videoNum', sortable: false, align: 'center' },
        { text: '未转换视频总数', value: 'noTransitionCount', sortable: false, align: 'center' },
        { text: '总大小', value: 'videoSize', sortable: false, align: 'center' },
        { text: '替换后章节视频总数', value: 'lessonReplaceCount', sortable: false, align: 'center' },
        { text: '替换后作业视频总数', value: 'questionReplaceCount', sortable: false, align: 'center' },
        { text: '已替换总大小', value: 'replaceSize265', sortable: false, align: 'center' },
        { text: '操作', value: 'actions', sortable: false, align: 'center' },
      ],
      pageList: [],
      pageTypeList: [],
      addDialogFlag: false,
      // 编辑切换显示
      editButFlag: false,
      // 编辑切换
      editSwitchFlag: false,
      editDisableFlg: false,
      addParam: {},
      updateParam: {},
      switchShow: true,
      updateId: '',
      orgList: [],
      navi: [{ name: "videoDataTotal" }],
    }),
    beforeMount() {
      this.$store.commit('SET_NAVI_DATA', this.navi);
    },
    created () {
      // 页面初期化
      this.comUtils.saveStorage(this.$store)
    },
    destroyed() {
      Hub.$off("modal-confirm", this.set);
    },
  mounted() {
    this.$nextTick(
      function() {
        Hub.$on("modal-confirm", this.set);
      }.bind(this)
    );
  },
    // 页面载入之前
    beforeRouteEnter (to, from, next) {
      next(vm => {
        // 判断是否是从菜单跳至此页面
        const isClear = vm.comUtils.checkUrl(from.name)
        // 如果是从菜单跳过来的 就 清除查询条件
        if (isClear === 'true') {
          vm.$store.commit('REMOVE_PAGE_MANAGEMENT_PARAMS')
          // vm.$store.commit('SET_PLAN_EXECUTE_PAGE', 1)
        }
        // 查询条件赋值
        vm.searchParam.organizationId = vm.$store.state.organizationId
        if (vm.$store.state.pageManagement_pageKnd !== undefined) {
          vm.searchParam.pageKnd = vm.$store.state.pageManagement_pageKnd
        }
        // 页面初期化
        vm.init()
        vm.searchPageList()
      })
    },
    methods: {
      async init () {
        const data = await listSearchInit()
        this.orgList = data.data.orgList

      },
      // 查询page列表
      async searchPageList () {
        var param = {
          organizationId: this.searchParam.organizationId,
          page: this.pageNum,
          limit: this.pageCount,
        }
        // 把查询条件存入缓存
        this.$store.commit('SET_PAGE_MANAGEMENT_PARAMS', param)
        const data = await totalSearch(param)
        if (data.data.searchList != null && data.data.searchList != '') {
          this.pageList = data.data.searchList
        }
        this.totalCount = data.data.totalCounts
        this.totalPages = Math.ceil(this.totalCount / this.pageCount)
      },
      // 点击查询
      doSearch (flag) {
        if (flag) {
          this.totalPages = 0
          this.pageNum = 1
          this.pageCount = 10
          this.totalCount = 0
        } else {
          // 查询条件赋值
          this.searchParam.pageName = this.$store.state.pageManagement_pageName
          this.searchParam.pageUrl = this.$store.state.pageManagement_pageUrl
          if (this.$store.state.pageManagement_pageKnd !== undefined) {
            this.searchParam.pageKnd = this.$store.state.pageManagement_pageKnd
          }
        }
        this.searchPageList()
      },
      // 新增 或修改
      handleAdd () {
        this.$router.push({
          name: 'page-management-add',
          params: {
            id:0,
          }
        })
      },
      // 点击修改
      handleUpdate (item) {
        this.$router.push({
          name: 'page-management-add',
          params: {
            id:item.id,
          }
        }) 
      },
      // 点击视频详情
      handleDetail (item) {
        this.$router.push({
          name: 'video_data_list',
          params: {
            orgId: item.orgId,
          },
        })
      },
      //点击学生详情
      handleStudentDetail (item) {
        this.$router.push({
          name: 'student_data_list',
          params: {
            orgId: item.orgId,
          },
        })
      },
      // 点击编辑
      editorganization () {
        if (this.editSwitchFlag === true) {
          this.editButFlag = false
        } else {
          this.editButFlag = true
          this.editSwitchFlag = false
          this.editDisableFlg = true
        }
      },
      set(value) {
      if (value == 1) {
        // 成功 页面刷新
        this.delConfirmYes();
      }
    },
    },

  }
</script>

<style lang="scss" scoped>
.box {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.main2 {
  position: relative;
  /*margin: 5px 30px 5px 30px;*/
  padding-top: 28px;
  display: flex;
  flex-wrap: wrap;
}

.search-result {
  display: block;
  position: relative;
  margin: 30px 25px 5px 25px;
}

.search-functions-headers {
  position: relative;
  display: flex;
  justify-content: space-between;
  top: 0;
}

.search-functions {
  position: relative;
  top: 0;
  display: flex;
}

.search-result-summary {
  display: flex;
  align-items: center;
}

.search-result-summary .summary {
  margin: 0 50px 0 0;
}

.search-result-table {
  border-spacing: 0px;
  padding-bottom: 50px;
  width: 100%;
  margin-top: 10px;
}

.table-header-row {
  height: 67px;
  background: #f6f6f6;
}

.table-header-row th {
  text-align: left;
  padding: 10px;
}

.table-result-row {
  height: 78px;
  font-weight: 500;
  color: #333333;
}

.table-result-row td {
  border-bottom: 1px solid #ebebeb;
  padding: 10px;
  text-align: left;
}

.btn-detail {
  margin: 0 20px 0 20px;
  color: #0171a3;
  cursor: pointer;
}

.btn-delete {
  color: #fd1f58;
  cursor: pointer;
}

.box-left {
  border-top: 1px solid black;
  border-bottom: 1px solid black;
  border-right: 1px solid black;
}

.box-right {
  border-top: 1px solid black;
  border-bottom: 1px solid black;
}

.timeDiscount{
  white-space: pre-line;
}
</style>
